import arrowImage from '../../../assets/img/icons/facebook.svg';

type FacebookIconProps = {
    alt?: string;
    className?: string | null;
};

function FacebookIcon({ alt = 'Facebook', className = null }: FacebookIconProps) {
    return <img src={arrowImage} className={className || undefined} alt={alt} />;
}

export default FacebookIcon;
